import { FileSearchItemSchema } from 'src/api/endpoints/contentHub';

import { publicGateway } from '../../../config';

export const fetchPublicPageFiles = async (
  pageId: number
): Promise<FileSearchItemSchema[]> => {
  const response = await publicGateway(
    process.env.REACT_APP_DOCUMENTS_API as string
  ).get(`/public/pages/${pageId}/files`);

  return response.data.data;
};
